export class Notification {
  notificationId!: number;
  notificationDate!: string;
  notificationType!: NotificationType;
  notificationObjectId!: number;
  notificationText!: string;
  isSeen!: boolean;
  data!: any
}
export class NotificationsModel {
  unSeenNotificationsCount!: number;
  pageData!: Notification[];
  pageNumber!: number;
  pageSize!: number;
  totalCount!: number;
}
export enum NotificationType {
  User = 'User',
  Payment = 'Payment',
  Voucher = 'Voucher',
  Restaurant = 'Restaurant',
  RestaurantStuff = 'RestaurantStuff',
  DiwanRole = 'DiwanRole',
  Reservition = 'Reservition',
  Group = 'Group',
  Announcement = 'Announcement',
  WareHouseReceiverPurchaseOrder = 'WareHouseReceiverPurchaseOrder',
  WareHouseSenderAcceptPurchaseOrder = 'WareHouseSenderAcceptPurchaseOrder',
  WareHouseSenderRejectPurchaseOrder = 'WareHouseSenderRejectPurchaseOrder',
  WareHouseReceiverNeedStok = 'WareHouseReceiverNeedStok',
  WareHouseSenderAcceptNeedStok = 'WareHouseSenderAcceptNeedStok',
  WareHouseSenderRejectNeedStok = 'WareHouseSenderRejectNeedStok',
  WareHouseReceiverSendStok = 'WareHouseReceiverSendStok',
  WareHouseSenderAcceptSendStok = 'WareHouseSenderAcceptSendStok',
  WareHouseSenderRejectSendStok = 'WareHouseSenderRejectSendStok'
}
